import React from "react";
import { Form } from "react-bootstrap";

interface RadioButtonProps {
    id: string;
    label: string;
    value: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({ id, label, value, checked, onChange }) => (
    <div className="custom-radio">
        <Form.Check
            type="radio"
            id={id}
            label={label}
            name="radioGroup"
            value={value}
            checked={checked}
            onChange={onChange}
            className="small"
        />
    </div>
);

export default RadioButton;
